// extracted by mini-css-extract-plugin
export default {"textbox":"Diagram_textbox__Url21","Diagram":"Diagram_Diagram__XA1d5","DiagramOuterContainer":"Diagram_DiagramOuterContainer__DPcOq"};